export const onTasksDateRangeChange = (date: Date) => {
    const monthStartDate = new Date(date)
    monthStartDate.setDate(1)
    monthStartDate.setHours(0, 0, 0, 0)

    const monthEndDate = new Date(date)
    monthEndDate.setMonth(monthEndDate.getMonth() + 1)
    monthEndDate.setDate(0)
    monthEndDate.setHours(23, 59, 59, 999)

    // Expand the filter range to include events that might span across months
    // Get the first day shown in the calendar
    const calendarStartDate = new Date(monthStartDate)
    const firstDayOfWeek = calendarStartDate.getDay()
    calendarStartDate.setDate(calendarStartDate.getDate() - firstDayOfWeek)
    calendarStartDate.setHours(0, 0, 0, 0)

    // Get the last day shown in the calendar (might be from next month)
    const calendarEndDate = new Date(monthEndDate)
    const lastDayOfWeek = calendarEndDate.getDay()
    const daysToAdd = lastDayOfWeek === 6 ? 0 : 6 - lastDayOfWeek
    calendarEndDate.setDate(calendarEndDate.getDate() + daysToAdd)
    calendarEndDate.setHours(23, 59, 59, 999)

    return {startDate: calendarStartDate, endDate: calendarEndDate}
}